import { AccessMemberGroup } from 'types'
import { useEffect, useState } from 'react'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useWorkspaceMembers } from 'hooks/useWorkspaceMembers'
import { useWorkspaceChannels } from 'hooks/useWorkspaceChannels'
import { useIsNotSelf } from 'hooks/useIsNotSelf'
import { isUndefined } from 'lodash/fp'
import { ourUuid } from '../../../../utils'

const defaultOptions = { includeGroups: true } as const

// todo: all of these hooks are relying on react state, which means we refetch this data every time this hook is used and don't share
// data between components. All of these hooks need to be refactored to use react-query so this data can be shared easily.
export const useMemberOptions = ({ includeGroups } = defaultOptions) => {
  const [workspaceGroup, setWorkspaceGroup] = useState<AccessMemberGroup>()
  const currentWorkspace = useCurrentWorkspace()
  const currentWorkspaceId = currentWorkspace?.key
  const workspaceMembers = useWorkspaceMembers(currentWorkspaceId, { includeInactive: false })
  const workspaceChannels = useWorkspaceChannels(currentWorkspaceId, true)
  const isNotSelf = useIsNotSelf()
  const accessMemberGroups = isUndefined(workspaceGroup) ? [] : [workspaceGroup]

  useEffect(() => {
    const members = workspaceMembers.filter(isNotSelf)
    const workspaceAccessGroup = {
      id: ourUuid(),
      label: 'Everyone-workspace',
      logo_url: currentWorkspace?.logo_url,
      name: 'Everyone in this workspace',
      members,
      channels: [],
    }
    if (members.length) {
      setWorkspaceGroup(workspaceAccessGroup)
    }
  }, [currentWorkspace, workspaceMembers, isNotSelf])

  return {
    users: workspaceMembers.filter(isNotSelf),
    channels: includeGroups ? workspaceChannels : [],
    accessMemberGroups: includeGroups ? accessMemberGroups : [],
  }
}
